/** Canonical privacy policy URL for public forms and marketing footers. */
export const PRIVACY_POLICY_URL = "/datenschutz";
